// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.home_card_pg_wrapper {
  position: relative;
  width: 100%;
  min-height: 90vh;
  background: #ffffff;
  box-sizing: border-box;
  font-family: 'Manrope', sans-serif;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

/* ---------- AURORA GRADIENT BACKGROUND ---------- */

.home_card_pg_bg3d {
  position: absolute;
  inset: 0;
  z-index: 0;
  overflow: hidden;
  pointer-events: none;
}

.home_card_pg_bg3d::before {
  content: '';
  position: absolute;
  inset: 0;
  background: #faf4fa;
}

/* ---------- FOREGROUND CONTENT ---------- */
.home_card_pg_grid_row {
  position: relative;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  padding: 48px 24px;
}

.home_card_pg_grid {
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  justify-content: center;
  gap: 28px;
  width: 100%;
  max-width: 900px;
}

.home_card_pg_card {
  position: relative;
  z-index: 2;
  flex: 1 1 380px;
  max-width: 450px;
  background: rgb(255, 255, 255);
  backdrop-filter: blur(18px);
  -webkit-backdrop-filter: blur(18px);
  border-radius: 20px;
  padding: clamp(24px, 4vw, 34px) clamp(18px, 3vw, 26px);
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);
  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.35s ease;
  animation: home_card_pg_popIn 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both;
  will-change: transform;
  isolation: isolate;
}

.home_card_pg_card::before {
  content: '';
  position: absolute;
  inset: -2px;
  z-index: -1;
  border-radius: 22px;
  padding: 2px;
  mask-composite: exclude;
  animation: home_card_pg_spinBorder 5s linear infinite;
}

@property --home_card_pg_angle {
  syntax: '<angle>';
  initial-value: 0deg;
  inherits: false;
}

@keyframes home_card_pg_spinBorder {
  to {
    --home_card_pg_angle: 360deg;
  }
}

.home_card_pg_card:hover {
  transform: translateY(-6px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55);
}

@keyframes home_card_pg_popIn {
  from {
    opacity: 0;
    transform: scale(0.85) translateY(24px);
  }

  to {
    opacity: 1;
    transform: scale(1) translateY(0);
  }
}

.home_card_pg_icon_wrap {
  position: relative;
  width: clamp(150px, 40vw, 306px);
  height: clamp(150px, 40vw, 290px);
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 18px;
  border-radius: 50%;
  overflow: hidden;
  background: radial-gradient(circle at 35% 30%, rgba(83, 0, 90, 0.459), rgb(255, 255, 254) 70%);
}



.home_card_pg_card:hover .home_card_pg_icon_wrap::before {
  opacity: 1;
}



.home_card_pg_icon {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transform-origin: center center;

}

/* ---------- REDUCED / SMOOTH HOVER WOBBLE ---------- */


.home_card_pg_card_title {
  position: relative;
  font-size: 30px;
  font-weight: 800;
  letter-spacing: 0.6px;
  color: #010036;
  margin: 0 0 10px 0;
  padding-bottom: 8px;
}

.home_card_pg_card_title::after {
  content: '';
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 0;
  height: 3px;
  border-radius: 2px;
  transform: translateX(-50%);
  background: #003c53;
  transition: width 0.35s ease;
}

.home_card_pg_card:hover .home_card_pg_card_title::after {
  width: 56px;
}

.home_card_pg_card_desc {
  font-size: 17px;
  font-weight: 500;
  line-height: 1.65;
  color: #000000;
  margin: 0 0 22px;
  text-align: justify;
  max-width: 360px;
  flex-grow: 1;
}

.home_card_pg_course_btn {
  font-family: 'Manrope', sans-serif;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: #48004b;
  color: #ffffff;
  border: none;
  border-radius: 100px;
  padding: 11px 26px;
  font-size: 18px;

  letter-spacing: 0.5px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease;
  will-change: transform;
}

.home_card_pg_course_btn::before {
  content: '';
  position: absolute;
  top: 0;
  left: -60%;
  width: 50%;
  height: 100%;
  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);
  transform: skewX(-20deg);
  transition: left 0.6s ease;
}

.home_card_pg_course_btn:hover {
  background: #003249;
  color: #faf9f7;
  box-shadow: 0 10px 24px rgba(255, 138, 92, 0.4);
  transform: translateY(-3px) scale(1.03);
}

.home_card_pg_course_btn:hover::before {
  left: 120%;
}

.home_card_pg_course_btn:active {
  transform: translateY(0) scale(0.98);
}

.home_card_pg_course_btn:hover {
  transform: translateX(4px);
}

/* ---------- RESPONSIVE ---------- */

@media (max-width: 900px) {
  .home_card_pg_grid {
    max-width: 500px;
  }

  .home_card_pg_card {
    flex: 1 1 100%;
    max-width: 420px;
  }
}

@media (max-width: 640px) {
  .home_card_pg_grid_row {
    padding: 40px 20px;
  }

  .home_card_pg_grid {
    max-width: 400px;
    gap: 22px;
  }
}

@media (max-width: 480px) {
  .home_card_pg_wrapper {
    min-height: 100dvh;
  }

  .home_card_pg_grid_row {
    padding: 32px 16px;
  }

  .home_card_pg_card {
    padding: 26px 18px;
  }

  .home_card_pg_card_desc {
    max-width: 100%;
  }

  .home_card_pg_course_btn {
    width: 100%;
    justify-content: center;
  }
}

@media (max-width: 360px) {
  .home_card_pg_icon_wrap {
    width: clamp(120px, 45vw, 150px);
    height: clamp(120px, 45vw, 150px);
  }
}

@media (prefers-reduced-motion: reduce) {
  .home_card_pg_card {
    animation: none;
  }

  .home_card_pg_icon,
  .home_card_pg_icon_wrap::before,
  .home_card_pg_course_btn::before,
  .home_card_pg_card::before {
    animation: none !important;
    transition: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/Components/HomeCard/HomeCard.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;EAClC,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,qDAAqD;;AAErD;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,6CAA6C;AAC7C;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,uBAAuB;EACvB,SAAS;EACT,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,mCAAmC;EACnC,mBAAmB;EACnB,sDAAsD;EACtD,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,2CAA2C;EAC3C,oFAAoF;EACpF,0EAA0E;EAC1E,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,YAAY;EAEZ,uBAAuB;EACvB,qDAAqD;AACvD;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;AAEA;EACE,kBAAkB;EAClB,gCAAgC;EAChC,iCAAiC;EACjC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,8FAA8F;AAChG;;;;AAIA;EACE,UAAU;AACZ;;;;AAIA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,+BAA+B;;AAEjC;;AAEA,wDAAwD;;;AAGxD;EACE,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,QAAQ;EACR,WAAW;EACX,kBAAkB;EAClB,2BAA2B;EAC3B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,cAAc;EACd,YAAY;EACZ,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;;EAEf,qBAAqB;EACrB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,2GAA2G;EAC3G,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,UAAU;EACV,UAAU;EACV,YAAY;EACZ,uFAAuF;EACvF,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,+CAA+C;EAC/C,uCAAuC;AACzC;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,qCAAqC;;AAErC;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,SAAS;EACX;AACF;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,WAAW;IACX,uBAAuB;EACzB;AACF;;AAEA;EACE;IACE,gCAAgC;IAChC,iCAAiC;EACnC;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;;;;IAIE,0BAA0B;IAC1B,gBAAgB;EAClB;AACF","sourcesContent":[".home_card_pg_wrapper {\n  position: relative;\n  width: 100%;\n  min-height: 90vh;\n  background: #ffffff;\n  box-sizing: border-box;\n  font-family: 'Manrope', sans-serif;\n  overflow: hidden;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n/* ---------- AURORA GRADIENT BACKGROUND ---------- */\n\n.home_card_pg_bg3d {\n  position: absolute;\n  inset: 0;\n  z-index: 0;\n  overflow: hidden;\n  pointer-events: none;\n}\n\n.home_card_pg_bg3d::before {\n  content: '';\n  position: absolute;\n  inset: 0;\n  background: #faf4fa;\n}\n\n/* ---------- FOREGROUND CONTENT ---------- */\n.home_card_pg_grid_row {\n  position: relative;\n  z-index: 2;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  padding: 48px 24px;\n}\n\n.home_card_pg_grid {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: stretch;\n  justify-content: center;\n  gap: 28px;\n  width: 100%;\n  max-width: 900px;\n}\n\n.home_card_pg_card {\n  position: relative;\n  z-index: 2;\n  flex: 1 1 380px;\n  max-width: 450px;\n  background: rgb(255, 255, 255);\n  backdrop-filter: blur(18px);\n  -webkit-backdrop-filter: blur(18px);\n  border-radius: 20px;\n  padding: clamp(24px, 4vw, 34px) clamp(18px, 3vw, 26px);\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.45);\n  transition: transform 0.35s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.35s ease;\n  animation: home_card_pg_popIn 0.55s cubic-bezier(0.34, 1.56, 0.64, 1) both;\n  will-change: transform;\n  isolation: isolate;\n}\n\n.home_card_pg_card::before {\n  content: '';\n  position: absolute;\n  inset: -2px;\n  z-index: -1;\n  border-radius: 22px;\n  padding: 2px;\n  -webkit-mask-composite: xor;\n  mask-composite: exclude;\n  animation: home_card_pg_spinBorder 5s linear infinite;\n}\n\n@property --home_card_pg_angle {\n  syntax: '<angle>';\n  initial-value: 0deg;\n  inherits: false;\n}\n\n@keyframes home_card_pg_spinBorder {\n  to {\n    --home_card_pg_angle: 360deg;\n  }\n}\n\n.home_card_pg_card:hover {\n  transform: translateY(-6px);\n  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.55);\n}\n\n@keyframes home_card_pg_popIn {\n  from {\n    opacity: 0;\n    transform: scale(0.85) translateY(24px);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1) translateY(0);\n  }\n}\n\n.home_card_pg_icon_wrap {\n  position: relative;\n  width: clamp(150px, 40vw, 306px);\n  height: clamp(150px, 40vw, 290px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-bottom: 18px;\n  border-radius: 50%;\n  overflow: hidden;\n  background: radial-gradient(circle at 35% 30%, rgba(83, 0, 90, 0.459), rgb(255, 255, 254) 70%);\n}\n\n\n\n.home_card_pg_card:hover .home_card_pg_icon_wrap::before {\n  opacity: 1;\n}\n\n\n\n.home_card_pg_icon {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  transform-origin: center center;\n\n}\n\n/* ---------- REDUCED / SMOOTH HOVER WOBBLE ---------- */\n\n\n.home_card_pg_card_title {\n  position: relative;\n  font-size: 30px;\n  font-weight: 800;\n  letter-spacing: 0.6px;\n  color: #010036;\n  margin: 0 0 10px 0;\n  padding-bottom: 8px;\n}\n\n.home_card_pg_card_title::after {\n  content: '';\n  position: absolute;\n  left: 50%;\n  bottom: 0;\n  width: 0;\n  height: 3px;\n  border-radius: 2px;\n  transform: translateX(-50%);\n  background: #003c53;\n  transition: width 0.35s ease;\n}\n\n.home_card_pg_card:hover .home_card_pg_card_title::after {\n  width: 56px;\n}\n\n.home_card_pg_card_desc {\n  font-size: 17px;\n  font-weight: 500;\n  line-height: 1.65;\n  color: #000000;\n  margin: 0 0 22px;\n  text-align: justify;\n  max-width: 360px;\n  flex-grow: 1;\n}\n\n.home_card_pg_course_btn {\n  font-family: 'Manrope', sans-serif;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  background: #48004b;\n  color: #ffffff;\n  border: none;\n  border-radius: 100px;\n  padding: 11px 26px;\n  font-size: 18px;\n\n  letter-spacing: 0.5px;\n  cursor: pointer;\n  position: relative;\n  overflow: hidden;\n  transition: transform 0.25s cubic-bezier(0.34, 1.56, 0.64, 1), box-shadow 0.25s ease, background 0.25s ease;\n  will-change: transform;\n}\n\n.home_card_pg_course_btn::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: -60%;\n  width: 50%;\n  height: 100%;\n  background: linear-gradient(120deg, transparent, rgba(255, 255, 255, 0.5), transparent);\n  transform: skewX(-20deg);\n  transition: left 0.6s ease;\n}\n\n.home_card_pg_course_btn:hover {\n  background: #003249;\n  color: #faf9f7;\n  box-shadow: 0 10px 24px rgba(255, 138, 92, 0.4);\n  transform: translateY(-3px) scale(1.03);\n}\n\n.home_card_pg_course_btn:hover::before {\n  left: 120%;\n}\n\n.home_card_pg_course_btn:active {\n  transform: translateY(0) scale(0.98);\n}\n\n.home_card_pg_course_btn:hover {\n  transform: translateX(4px);\n}\n\n/* ---------- RESPONSIVE ---------- */\n\n@media (max-width: 900px) {\n  .home_card_pg_grid {\n    max-width: 500px;\n  }\n\n  .home_card_pg_card {\n    flex: 1 1 100%;\n    max-width: 420px;\n  }\n}\n\n@media (max-width: 640px) {\n  .home_card_pg_grid_row {\n    padding: 40px 20px;\n  }\n\n  .home_card_pg_grid {\n    max-width: 400px;\n    gap: 22px;\n  }\n}\n\n@media (max-width: 480px) {\n  .home_card_pg_wrapper {\n    min-height: 100dvh;\n  }\n\n  .home_card_pg_grid_row {\n    padding: 32px 16px;\n  }\n\n  .home_card_pg_card {\n    padding: 26px 18px;\n  }\n\n  .home_card_pg_card_desc {\n    max-width: 100%;\n  }\n\n  .home_card_pg_course_btn {\n    width: 100%;\n    justify-content: center;\n  }\n}\n\n@media (max-width: 360px) {\n  .home_card_pg_icon_wrap {\n    width: clamp(120px, 45vw, 150px);\n    height: clamp(120px, 45vw, 150px);\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .home_card_pg_card {\n    animation: none;\n  }\n\n  .home_card_pg_icon,\n  .home_card_pg_icon_wrap::before,\n  .home_card_pg_course_btn::before,\n  .home_card_pg_card::before {\n    animation: none !important;\n    transition: none;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
